import {getFormatDate1,getFormatDate2} from '../insurance/index.js';

const getFields = (num) => {
  const infno = num;//接口编号
  const institutionId = 'H43010200354'
  // const institutionId = 'H43010300379'
  // const institutionId = 'H43011101276'
  // const institutionId = 'H43011102410'
  const time = getFormatDate1()
  console.log(time,'time');
  const order = '1234'
  const msgid = institutionId + time + order;//发送方报文ID
  const mdtrtarea_admvs = institutionId.substring(1,7);//就医地医保区划
  const insuplc_admdvs = '';//参保地医保区划
  const recer_sys_code = 'MBS_LOCAL';//接收方系统代码
  const dev_no = '';//设备编号
  const dev_safe_info = '';//设备安全信息
  const cainfo = '';//数字签名信息
  const signtype = '';//签名类型
  const infver = 'V1.0';//接口版本号
  const opter_type = '1';//经办人类别
  const opter = '01';//经办人 存疑
  const opter_name = '郝小章';//经办人姓名
  const inf_time = getFormatDate2()
  const fixmedins_code = institutionId;
  const fixmedins_name = '长沙市芙蓉区郝小章诊所';
  // const fixmedins_code = 'H43010300379';
  // const fixmedins_name = '长沙市天心区文源街道天鸿社区卫生服务站';
  // const fixmedins_code = 'H43011101276';
  // const fixmedins_name = '长沙市雨花区同升街道白田社区卫生服务站';
  // const fixmedins_code = 'H43011102410';
  // const fixmedins_name = '长沙市雨花区圭塘街道广顺源社区卫生服务站';
  const sign_no = '';//交易签到流水号

  return {
    infno,
    msgid,
    mdtrtarea_admvs,
    insuplc_admdvs,
    recer_sys_code,
    dev_no,
    dev_safe_info,
    cainfo,
    signtype,
    infver,
    opter_type,
    opter,
    opter_name,
    inf_time,
    fixmedins_code,
    fixmedins_name,
    sign_no
  };
}

export default getFields;